import {
  UsersResponse as Response,
  Uri,
  UserListData,
  UserListQueryParams,
  convertUserList,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useCrewSwapList(
  params: UserListQueryParams,
  storeId: string | undefined,
  enabled = true
) {
  const { server } = useServer()
  const uri = getUri()

  return useQuery({
    queryKey: uri ? keys.list(uri) : [],
    queryFn: fetchCrewSwapUserList,
    enabled: !!storeId && enabled,
  })

  async function fetchCrewSwapUserList(): Promise<UserListData> {
    const url = uri

    if (!url) {
      throw new Error('Illegal user list URL')
    }

    const response = await server.get<Response.UserList>(url)
    return convertUserList(response)
  }

  function getUri(): Uri | undefined {
    if (!storeId || !params.filter_shift_id) {
      return
    }

    return `/v2/helpers/me/stores/${storeId}/users/swap/${params.filter_shift_id}`
  }
}
